module.exports = __webpack_public_path__ + "img/photo2.2ef74664.png";